module.exports = __webpack_public_path__ + "static/brand-7907b5aec472cb7cfccaf75f16bb4648.png";